/** An anchored phrase matcher captures interpolation values without interpreting their content. */
export function messageFormatOf(phrase: string) {
  const variables: string[] = [];
  const parts: string[] = [];
  let offset = 0;
  const escape = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  for (const found of phrase.matchAll(/\{\{([^}]+)\}\}/g)) {
    parts.push(escape(phrase.slice(offset, found.index)), "([\\s\\S]*?)");
    variables.push(found[1]!);
    offset = found.index + found[0].length;
  }
  parts.push(escape(phrase.slice(offset)));
  return { expression: new RegExp(`^${parts.join("")}$`), variables,
    fixedLength: phrase.replace(/\{\{[^}]+\}\}/g, "").length };
}
